import { MessageSquarePlus, X } from "lucide-react";
import { useState } from "react";

import RoundFeedbackForm from "@/components/RoundFeedbackForm";
import useDialogFocus from "@/hooks/useDialogFocus";

export default function RoundFeedbackModal({ onClose, open }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dialogRef = useDialogFocus(open, onClose, isSubmitting);

  if (!open) return null;

  return (
    <div className="feedback-modal-backdrop" data-testid="round-feedback-modal">
      <section
        aria-labelledby="round-feedback-heading"
        aria-modal="true"
        className="feedback-modal"
        role="dialog"
        ref={dialogRef}
        tabIndex={-1}
      >
        <button
          aria-label="Close feedback"
          className="feedback-close-button"
          onClick={onClose}
          disabled={isSubmitting}
          data-testid="round-feedback-close-button"
        >
          <X size={18} />
        </button>
        <p className="eyebrow">
          <MessageSquarePlus size={14} /> Round complete
        </p>
        <h2 id="round-feedback-heading">How did that round feel?</h2>
        <RoundFeedbackForm onClose={onClose} onSubmittingChange={setIsSubmitting} />
      </section>
    </div>
  );
}